// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__d8_oI","alertIcon":"ConfirmModal_alertIcon__USqpS"};